import React from 'react'

export function DropdownIndicator(props)
{
    return(
        <div className={"enhanced-select__dropdown-indicator"} />
    )
}
